<script lang="ts">
	import FontSpan from '../typography/FontSpan.svelte';

	export let match: number;
	export let code: number;
	export let id: number;

	function getMatchIcon(_match: number) {
		switch (_match) {
			case -1:
				return 'reveal';
			case 0:
				return 'no';
			case 1:
				return 'six';
			case 2:
				return 'five';
			case 3:
				return 'four';
			case 4:
				return 'three';
			case 5:
				return 'two';
			case 6:
				return 'one';
			default:
				return '';
		}
	}

	$: matchIcon = getMatchIcon(match);

	function getCodeString(code: number) {
		return code == -1 || code == 0 ? '* * * * * *' : `${code}`;
	}

	function getCodeColor(code: number) {
		return code == -1 || code == 0 ? 'success' : `normal`;
	}

	$: codeString = getCodeString(code);
</script>

<div class="container flex rounded-md items-center {getCodeColor(code)}">
	<div class="image-container px-4 flex-col justify-center items-center">
		<div class="flex icon-zoom icon icon-match-ball-{matchIcon}39" />
	</div>
	<div class="flex flex-grow">
		<div class="flex w-full flex-col">
			<FontSpan varient="body-SB-04" class="text-white">Entry Code</FontSpan>
			<FontSpan varient="body-SB-05" class="text-gray-50">Ball ID</FontSpan>
		</div>
		<div class="flex w-full flex-col">
			<FontSpan varient="body-SB-04" class="text-white">{codeString}</FontSpan>
			<FontSpan varient="body-SB-05" class="text-gray-50">{id}</FontSpan>
		</div>
	</div>
</div>

<style>
	.icon-zoom {
		zoom: 1;
	}
	.success {
		border-radius: 6px;
		background: var(--p-80, #245a58);
		box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.45);
	}
	.normal {
		border-radius: 6px;
		background: var(--gray-200, #282828);
		box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.45);
	}
	.image-container {
		display: flex;
		/* height: 49px; */
		/* padding: 5px; */
		align-items: center;
		align-self: stretch;
	}
	.container {
		height: 60px;
		gap: 5px;
		align-self: stretch;
	}
</style>
